import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// import { HttpClient } from './httpclient.service';
import { Response } from '../interfaces';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class CodeqrService {
  
  constructor(private http: HttpClient, private API: ApiService) {
  }

  public getDatosVisaQR(): Observable<Response> {
    const body = {
      categoria: 'DATOS_VISA_QR'
    };
    return this.http.post<Response>(this.API.getParametersCat, body);
  }

  dinamicoQR(body: any): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('url', environment.urlQR);
    return this.http.post(this.API.qrniubizService, body, { params: httpParams });
  }
}